import ApiService from './apiService';
import { ApiOrderParams, PaginatedResponse } from './types';

type GetAllParams = ApiOrderParams & {
  page: number;
  pageSize: number;
  courseId?: number;
};

export const VideoCallRecordingService = {
  getAll: async ({
    page = 1,
    pageSize = 10,
    courseId,
    orderField,
    orderDirection,
  }: GetAllParams) => {
    const response = await ApiService.get<PaginatedResponse<VideoCallRecording>>(
      `/video-call-recordings`,
      {
        page,
        pageSize,
        courseId,
        orderField,
        orderDirection,
      }
    );

    return response.data;
  },
  sync: async () => {
    const response = await ApiService.post<void>(`/video-call-recordings/sync`, {});

    return response.data;
  },
};
